"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mnemonicToPKey = void 0;
const engine_1 = require("@railgun-community/engine");
const mnemonicToPKey = (mnemonic, derivationIndex) => {
    return `0x${(0, engine_1.mnemonicToPrivateKey)(mnemonic, derivationIndex)}`;
};
exports.mnemonicToPKey = mnemonicToPKey;
